import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Newsletter from 'components/layout/Newsletter';
import OurSponsors from './ticketing/pages/OurSponsors';
import useFetch from 'utils/hooks/useFetch';
import { GET_ALL_PUBLIC_POSTS } from 'api';

function Home() {
  const { data: publicPosts, fetch: getAllPublicPosts } = useFetch(GET_ALL_PUBLIC_POSTS)
  const { t } = useTranslation();

  useEffect(() => {
    getAllPublicPosts();
  }, [getAllPublicPosts])

  return (
    <div>
      <section className='hidden sm:block'>
        <div className='relative'>
          <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/a647ef9fdaa28d15a72619fec0f36e2f5ca0ea827affc93c74fabc74f098a5b16ae62b351ba1fb6e69ad3f5f56c461e67e7c8f20420e344a43d280fa38e1dec07f648ec772c9e45ecb5522eb6efcfdef3624d9e2dfb67a285c4ad5fda314aa005c3f1b84137ad65ed8d2af43eba7a5dbca3870722e85216a1ea8/file-1745900206629.jpeg" alt="main" className='max-h-[90vh] w-full object-cover object-center' />
          {/* <div className='absolute top-0 bottom-0 left-0 right-0 text-white'>
            <div className='app-main-container flex flex-col justify-center items-start h-full gap-4 sm:gap-8'>
              <p className='text-lg sm:text-3xl md:text-4xl max-w-md font-semibold sm:font-bold app-animation-translate-start'>{t('mainBannerText')}</p>
              <a href="/about">
                <button className='text-sm sm:text-base flex items-center gap-2 app-animation-translate-start'>
                  <p>{t('learnMore')}</p>
                  <ArrowRightIcon className='h-3 sm:h-4 w-3 sm:w-4 fill-white' />
                </button>
              </a>
            </div>
          </div> */}
        </div>
      </section>

      <section className='grid grid-cols-1 sm:grid-cols-2'>
        <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/18c918644b2ead6ece48509703de372de45ecc71e8aa1b76beb7599325dc8b525853f39a95698ff928a663d50154ab41fbfa3f0e654135d4d9b32335ee81da72725be74f3728f7e92e5acd5e092fba08c9dc8b39ecaf42798bb94417c12e408d5b214d99e544757428ef0bea3abc31fefe421356206e42332fe7/rez-file-1736347445718.JPG" alt="main" className='hidden sm:block w-full h-full aspect-video object-cover object-center app-animation-translate-right-start' />
        <img src="https://storage.googleapis.com/testing_storage_cloudxier/cloudxier-images/8fe31e99703fc7e6207be92efa99c1d8e8d8f08cf1ba46638f7df6bb53b00b21bc45bd070d7cebab46ee509c00cdea70701fde0a200b1bf1bd4dc81c0f03232a2632feb5205d6fd3cf5c28e080afc39dfb1d2edb5634e44db5c9ebec91579ec516a303db067b580b8c9e12ff9c92fafed75d572bb6440b1ed582/file-1745900234562.jpg" alt="main" className='sm:hidden w-full h-full object-cover object-center app-animation-translate-right-start' />
        <div className='bg-app-blue text-white px-4 py-6 md:py-12 md:px-10 lg:px-20 flex items-center justify-center sm:justify-start'>
          <div className='space-y-4 lg:space-y-8'>
            <p className='text-2xl lg:text-4xl uppercase font-bold max-w-lg app-animation-translate-start'>{t('aboutUsTitle1')}</p>
            <p className='text-xl lg:text-3xl font-bold max-w-lg app-animation-translate-start'>{t('firstHighlightText')}</p>
            <button onClick={() => window.location.assign('/prices')} className='text-lg sm:text-xl bg-app-blue-2 font-bold text-white rounded-md px-12 py-2 text-sm sm:text-base disabled:opacity-50 '>
              {t('registerNowButton')}
            </button>
          </div>
        </div>
      </section>

      {/* <section className='bg-app-grey'>
        <div className='app-main-container space-y-8'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('eSportConsultTitle2')}
          </p>
          <div className='text-app-blue text-sm sm:text-base max-w-2xl mx-auto'>{logo.generalBrands}</div>
        </div>
      </section> */}

      <OurSponsors landingPage={true} />

      {/* <section className='bg-app-grey'>
        <div className='app-main-container space-y-4'>
          <p className='text-xl sm:text-2xl font-bold text-app-blue text-center app-animation-translate-start'>
            {t('ourRecentEvents')}
          </p>
          <div className='grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-8 py-4'>

            {publicPosts?.filter(post => post?.tag?.toLowerCase() === "event").slice(0, 6).map((item, i) => (
              <div key={i} className='space-y-4'>
                <img className="w-full aspect-[4/3] object-cover border" src={item.img_cover} alt={item.title} />
                <p className='font-bold text-sm sm:text-lg'>{item.title}</p>
                <p className='font-semibold text-xs sm:text-base text-app-blue truncate'>{item.summary}</p>
                <a href={`article/${item?.id}`} className='flex items-center gap-2 text-xs sm:text-sm '>
                  <p>{t('learnMore')}</p>
                  <ArrowRightIcon className='h-2 w-2 sm:h-3 sm:w-3 fill-black' />
                </a>
              </div>
            ))}


          </div>
        </div>
      </section> */}

      {/* <Newsletter /> */}
    </div>
  )
}

export default Home